import type { ComponentType, JSX } from "react";
import type { Element } from "hast";
import { InsitiLink } from "./custom/insiti-link";
import { Table, Thead, Tbody, Tr, Th, Td } from "./custom/table";
import {
  FollowupQuestions,
  FollowupQuestion,
  FollowupChoice,
  FollowupOption,
} from "./custom/follow-up";
import { ChatChart } from "./custom/chart";

type ExtraProps = {
  node?: Element | undefined;
};

type MarkdownComponents = {
  [key: string]: ComponentType<
    JSX.IntrinsicElements[keyof JSX.IntrinsicElements] & ExtraProps
  >;
};

/**
 * Streamdown component overrides for the chat
 */
export const markdownComponents: MarkdownComponents = {
  a: InsitiLink,
  h1: (props) => <h1 className="text-xl font-semibold" {...props} />,
  h2: (props) => <h2 className="text-xl font-semibold" {...props} />,
  h3: (props) => <h3 className="text-xl font-semibold" {...props} />,
  ol: (props) => (
    <ol
      className="!mt-1.5 list-inside list-decimal whitespace-normal flex flex-col space-y-2"
      {...props}
    />
  ),
  ul: (props) => (
    <ul
      className="!mt-1.5 list-inside list-disc whitespace-normal flex flex-col space-y-2"
      {...props}
    />
  ),
  li: (props) => <li className="mx-3 [&>p]:inline" {...props} />,
  table: Table,
  thead: Thead,
  tbody: Tbody,
  tr: Tr,
  th: Th,
  td: Td,
  "followup-questions": FollowupQuestions,
  "followup-question": FollowupQuestion,
  "followup-choice": FollowupChoice,
  "followup-option": FollowupOption,
  chart: ({ spec }: { spec?: string }) => (
    <ChatChart spec={typeof spec === "string" ? spec : undefined} />
  ),
};
